import DisplayAds from './displayAds';
import getDisableAdSlots from './disableAdSlots';
import closest from 'dom-closest';

const refreshAdButtonsList = [
    '#scores-schedule-root .sns-daypicker-left-arrow',
    '#scores-schedule-root .sns-daypicker-right-arrow',
    '#scores-schedule-root .sns-daypicker-day-button',
    '#scores-schedule-root .react-datepicker .react-datepicker__navigation--previous',
    '#scores-schedule-root .react-datepicker .react-datepicker__navigation--next',
    '#scores-schedule-root .react-datepicker >div:last-child > button',
    '#scores-schedule-root .react-datepicker .react-datepicker__day'
];

export const reInitAd = (futureViewAdConfig, disableDesktopAd = false, disableMobileAd = false) => {
    const interstitialAdDisabled = { 'ad-1x2-interstitial': true };
    const adsDisabled = getDisableAdSlots(disableDesktopAd, disableMobileAd, {
        desktop: ['ad-scores-schedule-top-banner-m', 'ad-scores-schedule-sponsor-m'],
        mobile: ['ad-scores-schedule-top-banner-sm', 'ad-scores-schedule-sponsor-sm']
    });
    DisplayAds.init(futureViewAdConfig, { ...interstitialAdDisabled, ...adsDisabled });
};

export const initAdsRefresh = (adsConfig) => {
    document.getElementById('scores-schedule-root').addEventListener('click', (event) => {
        refreshAdButtonsList.forEach((selector) => {
            const closestTarget = closest(event.target, selector);
            if (closestTarget) {
                const currentView = document
                    .querySelectorAll('section[data-active-view]')[0]
                    .getAttribute('data-active-view');
                DisplayAds.refreshSlots(adsConfig[currentView]);
            }
        });
    });
};
